import React from "react";
import { Spinner } from "react-bootstrap";
import "./LoadingScreen.scss";

interface LoadingScreenProps {
  loadingText: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ loadingText }) => {
  return (
    <div className="loading-screen-overlay">
      <div className="loading-box">
        <Spinner animation="border" className="loading-spinner">
          <output className="visually-hidden">Cargando...</output>
        </Spinner>
        <output className="loading-text" aria-live="polite">{loadingText}</output>
      </div>
    </div>
  );
};

export default LoadingScreen;
